import { render, staticRenderFns } from "./EditSurveyWarning.vue?vue&type=template&id=1c72bf19&scoped=true"
import script from "./EditSurveyWarning.vue?vue&type=script&lang=js"
export * from "./EditSurveyWarning.vue?vue&type=script&lang=js"
import style0 from "./EditSurveyWarning.vue?vue&type=style&index=0&id=1c72bf19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c72bf19",
  null
  
)

export default component.exports